module.exports = __webpack_public_path__ + "img/Dantam Makeover 30.ee6f28bf.jpg";